import map from 'lodash/map'
import find from 'lodash/find'
import React, { useContext as useContextCore, useState } from 'react'
import { queries } from './graphql'
import { useList, useUser } from '@ztechapps/common.hook'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const ContentStates = {
  addItem: 'add-item',
  addBoard: 'add-board',
}

export const Provider = ({ children, ...props }) => {
  const [contentState, setContentState] = React.useState(ContentStates.addItem)
  const [show, setShow] = useState(false)
  const [selectedBoard, setSelectedBoard] = React.useState([])
  const onClose = () => setShow(false)
  const onShow = () => setShow(true)

  const hasSelected = React.useMemo(() => !!find(selectedBoard, { checked: true }), [selectedBoard])

  const { user } = useUser()
  const { list } = useList({
    ...queries.allConfig,
    filter: { users: { $elemMatch: { $eq: user?._id } } },
    limit: 0,
    sort: { createdAt: -1 },
  })

  React.useEffect(() => {
    const newList = map(list, (e) => ({ ...e, checked: false }))
    setSelectedBoard(newList)
  }, [list])

  return (
    <CoreProvider
      value={{
        ...props,
        show,
        selectedBoard,
        setSelectedBoard,
        hasSelected,
        onClose,
        onShow,
        contentState,
        setContentState,
        list,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
